module.exports = __webpack_public_path__ + "img/coin.975b615e.png";